import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import PasswordInput from '../Enter/fields/PasswordInput';
import SubmitButton from '../Enter/fields/SubmitButton';
import useQuery from '../../utils/useQuery';
import { validateLength } from '../../utils/validation';
import { sendUpdatePasswordRequest } from '../../utils/api/accountApi';
import styles from './NewPasswordForm.scss';

const NewPasswordForm = () => {
  const history = useHistory();
  const intl = useIntl();
  const { token } = useQuery();

  const [passInput, setPassInput] = useState('');
  const onPassInputChange = (e) => setPassInput(e.target.value);

  const [isLoading, setLoading] = useState(false);

  const [formErrors, setFormErrors] = useState({});

  const onSubmit = () => {
    setLoading(true);
    const passError = validateLength(passInput, 8, 21);

    if (passError) {
      setFormErrors({
        pass: passError,
      });
      setLoading(false);
    } else {
      sendUpdatePasswordRequest(passInput, token).then(() => {
        history.push('/enter/login');
      });
    }
  };

  return (
    <form className={styles.form}>
      <h2 className={styles.title}>
        <FormattedMessage
          id="setNewPassword.title"
          defaultMessage="Set new password"
          description="Title of the page sent to user on password reset request"
        />
      </h2>

      <PasswordInput passValue={passInput} error={formErrors.pass} label={null} onChange={onPassInputChange} />

      <SubmitButton
        isLoading={isLoading}
        text={intl.formatMessage({
          id: 'setNewPassword.submit',
          defaultMessage: 'Update password',
          description: 'Submit button, sets new password for the account',
        })}
        onSubmit={onSubmit}
      />
    </form>
  );
};

export default NewPasswordForm;
